"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableColumnsButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _styles = require("@material-ui/core/styles");
var _ProductSalableTable = require("../../ProductSalableTable");
var _tableHooks = require("../../tableHooks");
var _ApplyAndCancelButtons = require("./sharedComponents/ApplyAndCancelButtons");
var _excluded = ["appliedFilter", "setAppliedFilter", "setShownTableHeadColumns", "shownTableHeadColumns", "tableHeadColumns"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      maxWidth: "300px",
      maxHeight: "500px"
    },
    appBar: {
      padding: "0.5rem"
    },
    columnsWrapper: {
      overflow: "auto",
      padding: "1rem",
      paddingTop: "0.25rem"
    },
    arrowButton: {
      color: theme.palette.grey[800],
      "&:focus": {
        background: theme.palette.grey[100]
      }
    },
    collapse: {
      paddingLeft: "1rem"
    },
    bottomButtonsWrapper: {
      display: "flex",
      justifyContent: "space-between",
      padding: "1rem"
    },
    popover: {
      overflow: "auto"
    },
    paper: {
      display: "flex"
    }
  };
});
var TableColumnsButton = function TableColumnsButton(_ref) {
  var _appliedFilter$_sort;
  var appliedFilter = _ref.appliedFilter,
    setAppliedFilter = _ref.setAppliedFilter,
    setShownTableHeadColumns = _ref.setShownTableHeadColumns,
    shownTableHeadColumns = _ref.shownTableHeadColumns,
    tableHeadColumns = _ref.tableHeadColumns,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyle();
  var _usePopover = (0, _tableHooks.usePopover)(),
    anchorEl = _usePopover.anchorEl,
    open = _usePopover.open,
    handleOpen = _usePopover.handleOpen,
    handleClose = _usePopover.handleClose;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleOpen,
    variant: "outlined",
    startIcon: /*#__PURE__*/_react.default.createElement(_core.Icon, null, "view_week")
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "table_Colonnes",
    defaultMessage: "table_Colonnes"
  })), /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    className: classes.popover,
    PaperProps: {
      classes: {
        root: classes.paper
      }
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(TableColumns, _extends({
    setShownTableHeadColumns: setShownTableHeadColumns,
    shownTableHeadColumns: shownTableHeadColumns,
    tableHeadColumns: tableHeadColumns,
    orderBy: (_appliedFilter$_sort = appliedFilter._sort) === null || _appliedFilter$_sort === void 0 ? void 0 : _appliedFilter$_sort.replace("-", ""),
    setAppliedFilter: setAppliedFilter,
    appliedFilter: appliedFilter,
    handleClose: handleClose
  }, props))));
};
exports.TableColumnsButton = TableColumnsButton;
var TableColumns = function TableColumns(_ref2) {
  var setShownTableHeadColumns = _ref2.setShownTableHeadColumns,
    shownTableHeadColumns = _ref2.shownTableHeadColumns,
    tableHeadColumns = _ref2.tableHeadColumns,
    orderBy = _ref2.orderBy,
    handleClose = _ref2.handleClose,
    setAppliedFilter = _ref2.setAppliedFilter,
    appliedFilter = _ref2.appliedFilter,
    _ref2$nameInLocalStor = _ref2.nameInLocalStorage,
    nameInLocalStorage = _ref2$nameInLocalStor === void 0 ? "salableProducts" : _ref2$nameInLocalStor;
  var classes = useStyle();
  var _useState = (0, _react.useState)(shownTableHeadColumns),
    _useState2 = _slicedToArray(_useState, 2),
    headColumns = _useState2[0],
    setHeadColumns = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openCollapse = _useState4[0],
    setOpenCollapse = _useState4[1];
  (0, _react.useEffect)(function () {
    // This is used to remove sorting when the user hides the column
    return function () {
      if (orderBy && !shownTableHeadColumns.some(function (_ref3) {
        var value = _ref3.value;
        return value === orderBy;
      })) {
        var newAppliedFilter = _objectSpread({}, appliedFilter);
        delete newAppliedFilter._sort;
        setAppliedFilter(newAppliedFilter);
      }
    };
  }, [shownTableHeadColumns, orderBy, appliedFilter, setAppliedFilter]);
  var handleCollapse = function handleCollapse() {
    setOpenCollapse(!openCollapse);
  };
  var handleSelectAllClick = function handleSelectAllClick() {
    setHeadColumns(_ProductSalableTable.ALL_HEAD_COLUMNS_WITH_SPECIFICITIES);
  };
  var HandleDeselectAllClick = function HandleDeselectAllClick() {
    setHeadColumns([]);
  };
  var handleClickCheckbox = (0, _react.useCallback)(function (event) {
    if (event.target.value === "specificity") {
      if (headColumns.includes("specificity")) {
        setHeadColumns(headColumns.filter(function (column) {
          return !["specificity"].concat(_toConsumableArray(_ProductSalableTable.SPECIFICITIES)).includes(column);
        }));
      } else {
        setHeadColumns([].concat(_toConsumableArray(headColumns), ["specificity"], _toConsumableArray(_ProductSalableTable.SPECIFICITIES)));
      }
    } else {
      if (headColumns.includes(event.target.value)) {
        setHeadColumns(headColumns.filter(function (column) {
          return column !== event.target.value;
        }));
      } else {
        setHeadColumns([].concat(_toConsumableArray(headColumns), [event.target.value]));
      }
    }
  }, [headColumns]);
  var handleSpecificityCheckbox = (0, _react.useCallback)(function (event) {
    if (headColumns.includes(event.target.value)) {
      setHeadColumns(headColumns.filter(function (column) {
        return ![event.target.value, "specificity"].includes(column);
      }));
    } else {
      var newHeadColumns = [].concat(_toConsumableArray(headColumns), [event.target.value]);
      if (_ProductSalableTable.SPECIFICITIES.every(function (spec) {
        return newHeadColumns.includes(spec);
      })) {
        newHeadColumns.push("specificity");
        setHeadColumns(newHeadColumns);
      } else {
        setHeadColumns(newHeadColumns);
      }
    }
  }, [headColumns]);
  var handleApplyClick = (0, _react.useCallback)(function () {
    setShownTableHeadColumns(headColumns);
    localStorage.setItem("tableHeadColumns_".concat(nameInLocalStorage), JSON.stringify(headColumns));
    handleClose();
  }, [headColumns, setShownTableHeadColumns, handleClose, nameInLocalStorage]);
  var handleCancelClick = function handleCancelClick() {
    handleClose();
  };
  var checkIfColumnIsShown = (0, _react.useCallback)(function (column) {
    return headColumns.includes(column);
  }, [headColumns]);
  var isAllSelected = (0, _react.useMemo)(function () {
    return headColumns.length === _ProductSalableTable.ALL_HEAD_COLUMNS_WITH_SPECIFICITIES.length;
  }, [headColumns]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "static",
    color: "transparent"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: classes.appBar,
    alignItems: "center",
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
    checked: isAllSelected,
    onChange: isAllSelected ? HandleDeselectAllClick : handleSelectAllClick
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: isAllSelected ? "Deselect All" : "Select All",
    defaultMessage: isAllSelected ? "Deselect All" : "Select All"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.columnsWrapper
  }, tableHeadColumns.map(function (_ref4) {
    var label = _ref4.label,
      value = _ref4.value,
      specificities = _ref4.specificities,
      isAbleToShow = _ref4.isAbleToShow,
      filtreValue = _ref4.filtreValue;
    if (!isAbleToShow) return null;
    var isString = typeof value === 'string';
    if (value === "specificity") {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: value
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        alignItems: "center",
        container: true
      }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
        value: value,
        checked: checkIfColumnIsShown(value),
        onChange: handleClickCheckbox
      }), /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: label,
        defaultMessage: label
      })), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
        onClick: handleCollapse,
        className: classes.arrowButton
      }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, !openCollapse ? "keyboard_arrow_down" : "keyboard_arrow_up"))), /*#__PURE__*/_react.default.createElement(_core.Collapse, {
        className: classes.collapse,
        in: openCollapse
      }, specificities.map(function (_ref5) {
        var label = _ref5.label,
          value = _ref5.value;
        return /*#__PURE__*/_react.default.createElement(_core.Grid, {
          alignItems: "center",
          key: value,
          container: true
        }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
          value: value,
          checked: checkIfColumnIsShown(value),
          onChange: handleSpecificityCheckbox
        }), /*#__PURE__*/_react.default.createElement(_core.Typography, null, label));
      })));
    } else {
      return /*#__PURE__*/_react.default.createElement(_core.Grid, {
        alignItems: "center",
        key: isString ? value : filtreValue,
        container: true
      }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
        value: isString ? value : filtreValue,
        checked: checkIfColumnIsShown(isString ? value : filtreValue),
        onChange: handleClickCheckbox
      }), /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: label,
        defaultMessage: label
      })));
    }
  })), /*#__PURE__*/_react.default.createElement(_ApplyAndCancelButtons.ApplyAndCancelButtons, {
    onCancel: handleCancelClick,
    onApply: handleApplyClick
  }));
};